import { render, staticRenderFns } from "./PrgButton.vue?vue&type=template&id=4f61ca8e&"
import script from "./PrgButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrgButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f61ca8e')) {
      api.createRecord('4f61ca8e', component.options)
    } else {
      api.reload('4f61ca8e', component.options)
    }
    module.hot.accept("./PrgButton.vue?vue&type=template&id=4f61ca8e&", function () {
      api.rerender('4f61ca8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/PrgButton/PrgButton.vue"
export default component.exports